export const ACTIVE_CONVERSATION_QUERY_PARAMETER = "activeConversationId";

export function getQueryParameter(
  location: Location,
  parameterName: string,
): string | undefined {
  const queryParameters = new URLSearchParams(location.search);
  return queryParameters.get(parameterName) ?? undefined;
}
